import React from "react";
import {Icon} from "../core/Icon.jsx";

export function Select({label,hint,options=[],size="md",disabled=false,style,...rest}){
  const [focus,setFocus]=React.useState(false);
  const h=size==="sm"?"var(--control-h-sm)":size==="lg"?"var(--control-h-lg)":"var(--control-h)";
  return (
    <label style={{display:"block",...style}}>
      {label&&<span style={{display:"block",marginBottom:"6px",fontFamily:"var(--font-display)",fontSize:"var(--text-xs)",fontWeight:"var(--weight-semibold)",letterSpacing:"var(--tracking-wide)"}}>{label}</span>}
      <span style={{display:"flex",alignItems:"center",height:h,padding:"0 10px 0 12px",
        background:disabled?"var(--surface-sunken)":"var(--surface-card)",
        border:"1px solid "+(focus?"var(--cyan-500)":"var(--line-default)"),
        borderRadius:"var(--radius-control)",transition:"var(--transition-control)",
        boxShadow:focus?"0 0 0 3px var(--cyan-100)":"none"}}>
        <select disabled={disabled} onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false)}
          style={{all:"unset",flex:1,fontFamily:"var(--font-body)",fontSize:"var(--text-sm)",color:"var(--fg-1)",cursor:disabled?"not-allowed":"pointer"}} {...rest}>
          {options.map(o=>{const v=typeof o==="string"?o:o.value;const l=typeof o==="string"?o:o.label;return <option key={v} value={v}>{l}</option>;})}
        </select>
        <Icon name="chevron-down" size={15} strokeAlign="middle" style={{color:"var(--fg-3)"}}/>
      </span>
      {hint&&<span style={{display:"block",marginTop:"6px",fontSize:"var(--text-2xs)",color:"var(--fg-3)"}}>{hint}</span>}
    </label>
  );
}
